import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import useAuth from '../hooks/useAuth';
import TaskNotificationBell from './TaskNotificationBell';
import SupportWidget from './SupportWidget';
import './Layout.css';

const Layout = ({ children }) => {
  const { user, logout, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  // Close mobile menu when route changes
  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);

  // Close mobile menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (mobileMenuOpen && !e.target.closest('.user-menu') && !e.target.closest('.mobile-menu-toggle')) {
        setMobileMenuOpen(false);
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, [mobileMenuOpen]);

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  // Don't show header on login page
  if (!isAuthenticated || location.pathname === '/login') {
    return <>{children}</>;
  }

  const handleHubClick = () => {
    navigate('/hub');
  };

  const handleAdminClick = () => {
    navigate('/admin');
  };

  // Check if we're on specific pages
  const isSpecialOrdersPage = location.pathname.includes('/special-orders');
  const isLeagueUniformPage = location.pathname.includes('/league-uniform-management');
  const isIntakeQueuePage = location.pathname.includes('/intake-queue');
  const isMyDeskPage = location.pathname.includes('/my-desk');
  const isSpiritWearPage = location.pathname.includes('/spirit-wear');

  return (
    <div className="layout">
      <header className="header">
        <div className="header-content">
          <button className="logo-btn" onClick={handleHubClick}>
            HUB
          </button>
          {isSpecialOrdersPage ? (
            <span className="welcome-text" style={{ color: 'white', fontSize: '1.8rem', fontWeight: '900' }}>Special Order System</span>
          ) : isLeagueUniformPage ? (
            <span className="welcome-text" style={{ color: 'white', fontSize: '1.8rem', fontWeight: '900' }}>League Uniform Management</span>
          ) : isIntakeQueuePage ? (
            <span className="welcome-text" style={{ color: 'white', fontSize: '1.8rem', fontWeight: '900' }}>League Intake Queue</span>
          ) : isMyDeskPage ? (
            <span className="welcome-text" style={{ color: 'white', fontSize: '1.8rem', fontWeight: '900' }}>My Desk</span>
          ) : isSpiritWearPage ? (
            <span className="welcome-text" style={{ color: 'white', fontSize: '1.8rem', fontWeight: '900' }}>Spirit Wear Inventory</span>
          ) : (
            <span className="welcome-text">Welcome, {user?.firstName || 'User'}</span>
          )}
          {/* Mobile menu toggle button */}
          <button
            className="mobile-menu-toggle"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle menu"
          >
            {mobileMenuOpen ? '✕' : '☰'}
          </button>

          <div className={`user-menu ${mobileMenuOpen ? 'mobile-open' : ''}`}>
            {user?.role === 'admin' && (
              <button onClick={() => navigate('/my-desk')} className="my-desk-btn">
                My Desk
              </button>
            )}
            {user?.role === 'admin' && (
              <button onClick={() => navigate('/hub-assistant')} className="hub-assistant-btn">
                HUB Assistant
              </button>
            )}
            {user?.role === 'admin' && (
              <button onClick={() => navigate('/support-tickets')} className="support-btn">
                Support
              </button>
            )}
            {user?.role === 'admin' && (
              <button onClick={handleAdminClick} className="admin-btn">
                Admin
              </button>
            )}
            <TaskNotificationBell />
            <span className="user-name">{user?.firstName} {user?.lastName}</span>
            <button onClick={handleLogout} className="logout-btn">
              Logout
            </button>
          </div>
        </div>
      </header>
      <main className="main-content">
        {children}
      </main>
      <SupportWidget />
    </div>
  );
};

export default Layout;
